import InputTextarea from '../prime-react-overrides/input-text-area/InputTextarea'
import React from 'react'
import { useState } from 'react'
import Modal from '../prime-react-overrides/modal/Modal'
import Button from '../prime-react-overrides/button/Button'
import { useRequestRegularizationMutation, useGetManagerListQuery } from '../../services/attendance-portal/regularization'
import MultiSelect from '../prime-react-overrides/multi-select/MultiSelect'
import { Chip } from 'primereact/chip';
import { useEffect } from 'react'
import toast from 'react-hot-toast'

const RegularizeModal = ({ onShow, onHide, docId }) => {

    const [reasonText, setReasonText] = useState('')
    const [selectedManagers, setSelectedManagers] = useState(null)
    const [managerOptions, setManagerOptions] = useState([]);

    const [requestForRegularization, { isLoading }] = useRequestRegularizationMutation()
    const { data: departmentManagers } = useGetManagerListQuery(null, { skip: onShow })

    useEffect(() => {
      
      if (departmentManagers?.commonManagers && departmentManagers?.managers) {
        const managerList = []
        const alwaysSelectedManagers = []

        for (const commonManager of departmentManagers.commonManagers) {
          alwaysSelectedManagers.push({...commonManager, disabled: true, fullName: `${commonManager.firstName ?? " "} ${commonManager.lastName ?? " "}` })  
        }

        for (const manager of departmentManagers.managers) {
          managerList.push({...manager, disabled: false, fullName: `${manager.firstName ?? " "} ${manager.lastName ?? " "}` })  
        }

        setManagerOptions([...alwaysSelectedManagers, ...managerList])
        setSelectedManagers(alwaysSelectedManagers)
      }
    
      
    }, [departmentManagers])
    

    const handleRequest = async () => {
      
      if (reasonText.length <= 3) {
        toast.error("Please write a descriptive reason for your regularization request")
        return
      }

        const regularizationData = {
            reason: reasonText,
            managers: selectedManagers, 
            docId
        }
        const response = await requestForRegularization(regularizationData).unwrap()
        toast.success('Regularization request sent successfully')
        onHide()
    }

    const optionTemplate = (option) => {
      return (
        <div className='flex flex-column'>
            <small className='m-0'>{option.fullName}</small>
            <small className='text-xs'>{option.email}</small>
        </div>
      )
    }

    const selectedItemTemplate = (option) => {
      return <Chip label={option?.fullName} className='mr-2' />
    }

    return (
        <Modal className='RegularizeModal' header="Request for regularization" visible={onShow} onHide={onHide} draggable={false} breakpoints={{ '640px': '100vw' }} style={{ width: '60vw' }}>
            
            <label className="font-medium mb-2 text-left block">Choose Reporting Manager *</label>
            <MultiSelect className='w-full mb-3' value={selectedManagers} options={managerOptions} onChange={(e) => setSelectedManagers(e.value)} optionLabel="fullName" placeholder="Select Managers" filter 
              itemTemplate={optionTemplate} selectedItemTemplate={selectedItemTemplate} maxSelectedLabels={4} showSelectAll={false} selectedItemsLabel={`{0} Managers selected`}
            />
            
            <label className="font-medium mb-2 text-left block">Add Reason *</label>
            <InputTextarea value={reasonText} className='mb-3 w-full' onChange={(e) => setReasonText(e.target.value)} rows={7} autoResize
                placeholder='Type here...' />
            <div className="flex justify-content-between align-items-center">
                <div className='text-xs GrayText flex align-items-center'><i className="pi pi-info-circle mr-2" ></i>
                    This request will be sent to your manager(s) for approval.</div>
                <Button onClick={handleRequest} label="Send" loading={isLoading} />
            </div>
        </Modal>
    )
}

export default RegularizeModal